var exports = {
  "h": "trigger__VWDtQ2",
};

module.exports = exports;
